import { lazy, Suspense } from 'react';
import { motion } from 'framer-motion';
import Navbar from '@/components/feature/Navbar';
import CustomCursor from '@/components/feature/CustomCursor';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ExperienceSection from './components/ExperienceSection';
import GallerySection from './components/GallerySection';
import TeamSection from './components/TeamSection';
import TestimonialsSection from './components/TestimonialsSection';
import StatsSection from './components/StatsSection';
import LocationSection from './components/LocationSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <>
      <CustomCursor />
      <Navbar />
      <main className="relative">
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ExperienceSection />
        <GallerySection />
        <TeamSection />
        <TestimonialsSection />
        <StatsSection />
        <LocationSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}